export enum OPERATORS {
  MERCEDES = 'Mercedes',
  OTHER = 'Other',
}
